import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface Props {
    to: string;
    children: ReactNode;
    openOnNewTab?: boolean;
}

export const StyledLink = (props: Props) => {
    return (
        <Link
            to={props.to}
            target={props.openOnNewTab ? "_blank" : undefined}
            className="text-blue-800 hover:cursor-pointer hover:underline flex items-center gap-1"
        >
            {props.children}
        </Link>
    );
};

export default StyledLink;
